"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontageSetFormatter = void 0;
const MontageSetFormValidator_1 = require("./MontageSetFormValidator");
class MontageSetFormatter {
    static gewicht(options) {
        return MontageSetFormValidator_1.MontageSetFormValidator.gewicht(options);
    }
}
exports.MontageSetFormatter = MontageSetFormatter;
//# sourceMappingURL=MontageSetFormatter.js.map